import { useEffect } from 'react';

import { changeLocale } from './index';
import { storedLocale } from './LocaleSwitcher';
import { resolveLocale } from './locales';

/**
 * Put the shell into the right language, and keep it there (BP-19 rule 1).
 *
 * The chain is `localStorage` first, then whatever the caller knows: the staff shell
 * passes `GET /me`'s already-resolved `locale` (user → tenant → `en`), the client
 * shell passes the device language (rule 6). This browser's remembered choice wins
 * over both, because somebody who picked a language on this tablet picked it for
 * this tablet.
 *
 * It only ever *reads* the stored value. Writing one here would make a device
 * language sticky — change the phone to Marathi, open the app once, and the app
 * would stay Marathi after the phone went back to English. Only the switcher writes.
 */
export function useAppLocale(fallback: string | null | undefined): void {
  useEffect(() => {
    changeLocale(resolveLocale(storedLocale(), fallback));
  }, [fallback]);
}
